import React from 'react';
import classnames from 'classnames';
import s from './GroupLinkLoader.scss';

export interface Props {
  isCollapsed?: boolean;
  className?: string;
}

const GroupLinkLoader: React.FC<Props> = ({ className, isCollapsed }) => {
  return (
    <div
      className={classnames(
        s['root'],
        isCollapsed && s['collapsed'],
        className
      )}
    >
      <div className={s['avatar']} />
      {!isCollapsed && <div className={s['username']} />}
    </div>
  );
};
GroupLinkLoader.displayName = 'GroupLinkLoader';

export default GroupLinkLoader;
